/**
 * Input validator to make sure this field matches another field.
 * Useful for confirm password fields.
 *
 * @example `
 * <input type="password" ng-model="password1">
 * <input type="password" ng-model="password2" match-password="password1">
 * `
 */
export default /* @ngInject */ function matchPassword($parse) {
    return {
        require: 'ngModel',
        link: function(scope, element, attrs, ngModel) {
            ngModel.$validators.match_password = function(value) {
                return (!angular.isDefined(value)
                || value === $parse(attrs.matchPassword)(scope));
            };
            scope.$watch(attrs.matchPassword, () => {
                ngModel.$validate();
            });
        }
    };
}



// WEBPACK FOOTER //
// ./forms/validators/match-password.js